import { PencilIcon, LockClosedIcon, UserCircleIcon, GlobeAltIcon } from '@heroicons/react/24/outline';
import { CourseNodeStatus } from 'types/domain/course';

export const CourseNodeStatusOptions = [
  // {
  //   name: 'Draft',
  //   component: (
  //     <div className="flex justify-start items-center text-gray-300">
  //       <PencilIcon className="w-4 h-4 mr-2" /> <span>Draft</span>
  //     </div>
  //   ),
  //   value: CourseNodeStatus.DRAFT,
  // },
  // {
  //   name: 'Private',
  //   component: (
  //     <div className="flex justify-start items-center">
  //       <LockClosedIcon className="w-4 h-4 mr-2  text-red-400" /> <span>Logged in</span>
  //     </div>
  //   ),
  //   value: CourseNodeStatus.PRIVATE,
  // },
  {
    name: 'Identified',
    component: (
      <div className="flex justify-start items-center ">
        <UserCircleIcon className="w-4 h-4 mr-2 text-yellow-500" /> <span>Identified</span>
      </div>
    ),
    value: CourseNodeStatus.IDENTITY,
  },
  {
    name: 'Public',
    component: (
      <div className="flex justify-start items-center ">
        <GlobeAltIcon className="w-4 h-4 mr-2 text-green-500" /> <span>Anyone</span>
      </div>
    ),
    value: CourseNodeStatus.PUBLIC,
  },
];


export const NodeStatusMessage = (status: CourseNodeStatus, iconClass: string = 'w-4 h-4 mr-2') => {
  switch (status) {
    case CourseNodeStatus.DRAFT:
      return (
        <div className="flex justify-start items-center">
          {/* <PencilIcon className={`${iconClass}`} /> */}
          <span>Inactive workflow. Cannot be accessed by learners</span> 
        </div>
      );
    case CourseNodeStatus.PUBLIC:
      return (
        <div className="flex justify-start items-center ">
          {/* <GlobeAltIcon className={`${iconClass} text-green-500`} />  */}
          <span>Anyone with this link can access</span>
        </div>
      );
    case CourseNodeStatus.IDENTITY:
      return (
        <div className="flex justify-start items-center ">
          {/* <UserCircleIcon className={`${iconClass} text-yellow-500`} /> */}
          <span>Learner's will be required to provide verified email to continue</span>
        </div>
      );
    case CourseNodeStatus.SELF_SIGNUP:
      return (
        <div className="flex justify-start items-center">
          {/* <LockClosedIcon className={`${iconClass} text-orange-500`} /> */}
          <span>Learner's will be required to sign up for an account to continue</span>
        </div>
      );
    case CourseNodeStatus.PRIVATE:
      return (
        <div className="flex justify-start items-center">
          {/* <LockClosedIcon className={`${iconClass} text-red-500`} /> */}
          <span>Only invited learner's with an account can access</span>
        </div>
      );
  }
};
